// ----------------------------------------------------------------------
// <copyright file="Izenda.Secutiry.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');
  const { reduce, isObject } = require('lodash/fp');

  function Security() {
    this.tenantFieldDefaultValue = '';
    this.showTenantFieldDefaultValue = true;
    this.additiveFieldAutoVisibleDefaultValue = false;
    this.additiveFieldAutoFilterableDefaultValue = false;

    var props = {
      tenantFieldValue: '',
      tenantFields: [],
      showTenantFieldValue: false,
      additiveFieldAutoVisibleValue: false,
      additiveFieldAutoFilterableValue: false,
      tenantId: null,
      errors: [],
      isSystemMode: true,
      alertMessage: commonMessages.EMPTY_MESSAGE,
      modified: null
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * Read Securtity Data
   */
  Security.prototype.readSecuritySetting = m.action(function(result) {
    result = result || {};

    this.tenantFieldValue = result.tenantFieldValue;
    this.tenantFields = result.tenantFields;
    this.showTenantFieldValue = result.showTenantFieldValue;
    this.additiveFieldAutoVisibleValue = result.setAdditiveFieldAutoVisibleValue;
    this.additiveFieldAutoFilterableValue = result.setAdditiveFieldAutoFilterableValue;

    this.tenantFieldDefaultValue = result.tenantFieldDefaultValue;
    this.showTenantFieldDefaultValue = result.showTenantFieldDefaultValue;
    this.additiveFieldAutoVisibleDefaultValue = result.setAdditiveFieldAutoVisibleDefaultValue;
    this.additiveFieldAutoFilterableDefaultValue = result.setAdditiveFieldAutoFilterableDefaultValue;
    this.tenantId = result.tenantId;

    this.modified = result.modified;

    // Reset Dirty
    this.resetDirty();
  });

  /**
   * Reset tenant field value
   */
  Security.prototype.resetTenantFieldValue = m.action(function() {
    this.tenantFieldValue = this.tenantFieldDefaultValue;
    this.markDirty();
  });

  /**
   * Update Tenant Field
   */
  Security.prototype.updateTenantField = m.action(function(value) {
    this.tenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Add new Tenant Field
   */
  Security.prototype.addNewTenantField = m.action(function(newValue) {
    this.tenantFieldValue += ';' + newValue;
    this.markDirty();
  });

  /**
   * Update Show Tenant Field
   */
  Security.prototype.updateShowTenantField = m.action(function(value) {
    this.showTenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Update Additive Field Auto Filterable Value
   */
  Security.prototype.updateFieldsFilterable = m.action(function(value) {
    this.additiveFieldAutoFilterableValue = value;
    this.markDirty();
  });

  /**
   * Update Additive Field Auto Visible Value
   */
  Security.prototype.updateFieldVisible = m.action(function(value) {
    this.additiveFieldAutoVisibleValue = value;
    this.markDirty();
  });

  /**
   * Get System Tenant Fields
   */
  Security.prototype.getSystemTenantFields = function() {
    var tenantFields = this.tenantFields || [];
    return reduce(
      function(result, field) {
        if (field.isSystem) {
          result = result + field.name + ';';
        }
        return result;
      },
      '',
      tenantFields
    );
  };

  /**
   * Build save data
   */
  Security.prototype.buildSaveData = function(tenantId) {
    return {
      tenantFieldValue: this.tenantFieldValue,
      showTenantFieldValue: this.showTenantFieldValue,
      setAdditiveFieldAutoVisibleValue: this.additiveFieldAutoVisibleValue,
      setAdditiveFieldAutoFilterableValue: this.additiveFieldAutoFilterableValue,
      tenantId: tenantId,
      modified: this.modified
    };
  };

  /**
   * Reset error message
   */
  Security.prototype.resetErrorMessage = function() {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  };

  /**
   * Show alert message after save
   */
  Security.prototype.showAlertMessage = function(result) {
    var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
    if (!result.success) {
      var messageData = result.messages[0];
      if (isObject(messageData)) {
        message = messageData.messages;
      } else {
        message = messageData;
      }
    }

    this.alertMessage = {
      type: result.success ? 'success' : 'error',
      message: message
    };
    return null;
  };

  module.exports = Security;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Security.js